module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "THDCustomer"
// module id = 11
// module chunks = 0